<template>
  <div class="saleDetail">
    <div class="title">
      <div>
        <input placeholder="开始日期" type="date" @input="choosestart1" v-model="start_time1"/> —
        <input placeholder="结束日期" type="date" @input="chooseend1" v-model="end_time1"/>
      </div>

    </div>
    <div class="head special" v-if="show">
      <div class="first">排名</div>
      <div class="second">学校</div>
      <div class="third">销售金额</div>
    </div>
    <div class="head" v-for="(item,index) in lists">
      <div class="first">{{index+1}}</div>
      <div class="second">{{item.school_name}}</div>
      <div class="third">￥{{item.order_amount}}</div>
    </div>
    <div class="head special" v-if="show">
      <div class="first"></div>
      <div class="second">汇总：</div>
      <div class="third">{{total}}</div>
    </div>
    <div class="none" v-if="none">暂无数据</div>
  </div>
</template>

<script>
    import saleDetail from '@/components/saleDetail'
    let school_id
    let link='http://ap.bjcreate.net/school/'
    let openid
    let start_time
    let end_time
    export default {
        name: "saleDetail",
        data () {
        return {
          value1:'',
          start_time1:'',
          end_time1:'',
          lists:[

          ],
          none:false,
          show:false,
          total:0
        }
      },
      mounted() {
        openid=this.$route.query.openid
        school_id=this.$route.query.school_id
        start_time=this.$route.query.start_time
        end_time=this.$route.query.end_time
        this.value1=[start_time,end_time]
        this.start_time1=start_time
        this.end_time1= end_time
        // school_id=this.$route.query.school_id
        // openid=this.$route.query.openid
        // start_time=this.$route.query.start_time
        // end_time=this.$route.query.end_time
        this.saledetail()
      },
      created() {


      },
      methods:{
        //
        saledetail(){
          this.$axios.post(link+'api/school/getorderamountdetails',
            {
              openid:openid,
              school_id:school_id,
              start_time:start_time,
              end_time:end_time
            }
          ).then(res=>{
            console.log(res.data)
            this.lists=res.data.ResultData
            if(res.data.ResultData&&res.data.ResultData.length>0){
              res.data.ResultData.forEach(value=>{
                this.total+=value.order_amount
              })
              this.none=false
              this.show=true
            }else{
              this.none=true
              this.show=false
            }
          }).catch(error=>{
            console.log(error)
          })
        },
        choosestart1(e){
          this.start_time1=e.target.value
          start_time=e.target.value
          this.saledetail(school_id,this.start_time1,this.end_time1)
        },
        chooseend1(e){
          console.log(e.target.value)

          end_time=e.target.value
          this.end_time1=e.target.value
          this.saledetail(school_id,this.start_time1,this.end_time1)
        },
        jump(item) {
          console.log(item)
          this.$router.push({
            path:'saleDetail'
            //path:'detail?id='+item.id
            //name:`detail`,query:{id:item.id}
          })
        }
      },
      components:{
        saleDetail
      }
    }
</script>

<style scoped>
  .title{
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height:0.8rem;
    font-size:0.32rem;
    background-color: #fff;
    max-width:6.8rem;
    margin:0 auto 0;
    padding:0.2rem 0;
  }
  .title input{
    height:1rem;
    line-height:1rem;
    border:1px solid #ddd;
    background-color:#fff;
    padding-left:0.1rem;
    font-size:0.3rem;
    -webkit-appearance: none;
  }
  .none{
    text-align: center;
    color:#666;
    font-size:0.3rem;
    margin-top:1rem;
  }
  body{
    background-color:#fff;
  }
  .saleDetail{
    padding:0 0.3rem;
  }
  .el-date-editor--daterange.el-input__inner{
    width:280px;
    margin-bottom:0.3rem;
  }
  .head{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size:0.24rem;
    line-height:0.88rem;
    border-bottom:1px solid #eaeaea;
    color:#555555;
  }
  .head.special{
    color:#000;
    background-color:#FAFAFA;
  }
  .first{
    width:1.35rem;
  }
  .second{
    width:3.2rem;
  }
  .third{
    width:1.6rem;
  }
  .fourth{
    color:#feac4e;
  }
</style>




// WEBPACK FOOTER //
// src/components/sale.vue